import { render, staticRenderFns } from "./Lyruna.vue?vue&type=template&id=8290bed0&"
import script from "./Lyruna.vue?vue&type=script&lang=js&"
export * from "./Lyruna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports